/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:18:41
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/readMore.js
 */
import { t } from '../../libs/i18n'
export default {
    // readMore
    readMore: {
        showHeight: 400,
        toggle: false,
        closeText: t("up.readMore.expand"),
        openText: t("up.readMore.fold"),
        color: '#2979ff',
        fontSize: 14,
        textIndent: '2em',
        name: ''
    }
}
